import Alpine from 'alpinejs';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

Alpine.data('timetunnel', () => ({
    media: null,

    init() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        const timeTunnel = this.$root;
        const pin = timeTunnel.querySelector('.time-tunnel__pin');
        const stage = timeTunnel.querySelector('.time-tunnel__stage');
        const items = gsap.utils.toArray(timeTunnel.querySelectorAll('[data-time-tunnel-item]'));

        if (!pin || !stage || !items.length) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        this.media = gsap.matchMedia();
        this.media.add('all', () => {
            const contentInners = gsap.utils.toArray(
                timeTunnel.querySelectorAll('[data-time-tunnel-browser-content]')
            );

            gsap.set(stage, { perspective: 1200 });
            gsap.set(items, {
                position: 'absolute',
                left: '50%',
                top: () => (window.matchMedia('(max-width: 767px)').matches ? '42%' : '50%'),
                opacity: (index) => (index === 0 ? 1 : 0),
                scale: (index) => (index === 0 ? 1 : window.matchMedia('(max-width: 767px)').matches ? 0.52 : 0.35),
                z: (index) => (index === 0 ? 0 : window.matchMedia('(max-width: 767px)').matches ? -520 : -900),
                xPercent: -50,
                yPercent: -50,
                rotateZ: (index) => (index === 0 ? 0 : index % 2 === 0 ? -7 : 7),
            });
            gsap.set(contentInners, { yPercent: 0 });

            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: timeTunnel,
                    start: 'top top',
                    end: () => `+=${items.length * (window.matchMedia('(max-width: 767px)').matches ? 360 : 460)}`,
                    pin,
                    scrub: true,
                    anticipatePin: 1,
                    invalidateOnRefresh: true,
                },
            });

            items.forEach((item, index) => {
                const position = index * 0.85;
                const contentInner = item.querySelector('[data-time-tunnel-browser-content]');

                timeline
                    .to(
                        item,
                        {
                            opacity: 1,
                            scale: 1,
                            z: 0,
                            xPercent: -50,
                            yPercent: -50,
                            rotateZ: 0,
                            duration: 0.7,
                            ease: 'power1.out',
                        },
                        position
                    );

                if (contentInner) {
                    timeline.to(
                        contentInner,
                        {
                            y: () => {
                                const content = contentInner.closest('.time-tunnel__browser-content');
                                const overflow = content
                                    ? contentInner.getBoundingClientRect().height -
                                      content.getBoundingClientRect().height
                                    : 0;

                                return Math.min(0, overflow * -1);
                            },
                            duration: 1.15,
                            ease: 'none',
                        },
                        position + 0.1
                    );
                }

                timeline
                    .to(
                        item,
                        {
                            opacity: index === items.length - 1 ? 1 : 0,
                            scale: () =>
                                index === items.length - 1 ||
                                window.matchMedia('(max-width: 767px)').matches
                                    ? 1
                                    : 1.22,
                            z: index === items.length - 1 ? 0 : 420,
                            xPercent: -50,
                            yPercent: -50,
                            duration: 0.7,
                            ease: 'power1.in',
                        },
                        position + 0.65
                    );
            });

            return () => {
                timeline.kill();
                gsap.set([stage, ...items, ...contentInners], { clearProps: 'all' });
            };
        });

        requestAnimationFrame(() => ScrollTrigger.refresh());
    },

    destroy() {
        this.media?.revert();
    },
}));
